export const INFO_MSG = 'info_msg';
export const WARN_MSG = 'warn_msg';
export const ERROR_MSG = 'error_msg';
export const DISMISS_ALL = 'dismiss_all';

export const LOADING = 'loading';

export const SWITCH_MODE_CALENDRIER = 'switch_mode_calendrier';
export const SELECT_MOIS = 'select_mois';
export const SELECT_SEMAINE_INDEX = 'select_semaine_index';

export function infoMessage(message) {
  return {type: INFO_MSG, message};
}

export function warnMessage(message) {
  return {type: WARN_MSG, message};
}

export function errorMessage(message) {
  return {type: ERROR_MSG, message};
}

export function dismissAll() {
  return {type: DISMISS_ALL};
}

export function loading(active) {
  return {type: LOADING, active};
}

export function switchModeCalendrier() {
  return {type: SWITCH_MODE_CALENDRIER};
}

export function selectMois(mois) {
  return {type: SELECT_MOIS, mois};
}

export function selectSemaineIndex(semaineIndex) {
  return {type: SELECT_SEMAINE_INDEX, semaineIndex};
}
